import { useEffect, useContext, useState } from "react";
import UserContext from "../../contexts/UserContext";
import Utils from "../../Utils";
import axios from "axios";
import moment from "moment";
import _ from "lodash";

import PhNotifications from "../../components/photographer/PhNotifications";
import PhCertification from "../../components/photographer/PhCertification";

const PhDashboard = (props) => {
  const { userData, isCertified } = useContext(UserContext);

  const { certificate } = userData;

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const getAttrArr = (hotelAttrs) => {
    if (!hotelAttrs) return "";

    const parts = hotelAttrs.split("#");
    return parts;
  };

  /* Hotel types */
  const hotel_types = {
    new: "New Property",
    converted: "Converted Property",
    established: "Established Property",
  };

  /* Classes for specific status */
  const statusClasses = {
    "In-Process": "status-pill inline-block bg-yellow-100 text-yellow-800",
    Pending: "status-pill inline-block bg-pink-50 text-pink-700",
    Completed: "status-pill inline-block bg-gray-200 text-gray-700",
  };
  /* Labels for status */
  const getStatusLabel = (status) => {
    const code = Number(status);

    if (code === 0 || code === 1) return "Pending";
    if (code >= 2 && code <= 6) return "In-Process";
    if (code === 7 || code === 8) return "Completed";

    return "Unknown";
  };
  const hotelDetailsFromAttrs = (attrs) => {
    return attrs.split("#");
  };

  const renderBell = (st) => {
    const redStatus = [1, 2, 3, 5, 7, 9, 11];
    return (
      <div>
        <i
          className={`fas fa-bell text-${redStatus.includes(Number(st)) ? "red" : "green"}-500`}
        ></i>{" "}
        {status[st + 1]}
      </div>
    );
  };

  /* Getting status for number */
  const [status, setStatus] = useState([]);
  useEffect(() => {
    axios
      .get(Utils.apiUrl(`psstatus`), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setStatus(res.data.statuses);
        }
      })
      .catch((err) => {
        //callback(false, err.message);
      });
  }, []);

  const [photoshoots, setPhotoshoots] = useState([]);
  useEffect(() => {
    if (isCertified()) {
      axios
        .get(
          Utils.apiUrl(`photoshoot/listing?sortBy=created_at&sortDir=desc`),
          Utils.apiHeaders(),
        )
        .then((res) => {
          console.log(res.data);
          if (res.data.success) {
            setPhotoshoots(res.data.data);
            //setHotelDetailsAttr(hotelDetailsFromAttrs(res.data.data[0].hotel_attrs));
          }
        })
        .catch((err) => {
          //callback(false, err.message);
        });
    }
  }, []);

  return (
    <>
      <div className="container mx-auto px-8 py-8">
        <div className="h1-wrapper">
          <h1 className="text-3xl font-bold text-gray-800">
            Photographer Dashboard
          </h1>
          {isCertified() && (
            <>
              <div
                className="certification-icon-header valid"
                title="Certification Status"
              >
                <i className="fas fa-certificate"></i>
              </div>
              <div className="ml-3 text-sm text-gray-600">
                <p className="text-md font-bold">
                  Photography Course Certification Complete
                </p>
                <div className="flex items-center gap-2 mt-1">
                  <span className="text-green-500">Valid till:</span>
                  <span className="badge flex items-center gap-2">
                    <i
                      className="fas fa-calendar-alt"
                      style={{ color: "#FF9362" }}
                    ></i>
                    {moment(certificate.expires_by).format("DD-MMM-YYYY")}
                  </span>
                </div>
              </div>
            </>
          )}
          {!isCertified() && (
            <>
              <div
                className="certification-icon-header invalid"
                title="Certification Status"
              >
                <i className="fas fa-exclamation-triangle"></i>
              </div>
              {_.get(certificate, "attempted", false) && (
                <div>
                  <strong>Expired on:</strong>{" "}
                  {moment(certificate.expires_by).format("DD-MMM-YYYY")}
                </div>
              )}
              {!_.get(certificate, "attempted", false) && (
                <>Not yet attempted</>
              )}
            </>
          )}
        </div>

        {!isCertified() && (
          <div className="flex items-start gap-3 rounded-lg border border-yellow-300 bg-yellow-50 p-4 text-yellow-800">
            <svg
              className="h-6 w-6 flex-shrink-0 text-yellow-500"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M12 9v4m0 4h.01M5.07 19h13.86c1.54 0 2.5-1.67 1.73-3L13.73 4c-.77-1.33-2.69-1.33-3.46 0L3.34 16c-.77 1.33.19 3 1.73 3z"
              />
            </svg>

            <div>
              <h3 className="font-semibold">Certification Required</h3>
              <p className="mt-1 text-sm">
                You must complete your certification before proceeding. Please
                get certified to unlock this feature.
              </p>

              <a
                href="/get-certified"
                className="mt-3 inline-block rounded-md bg-yellow-600 px-4 py-2 text-sm font-medium text-white hover:bg-yellow-700"
              >
                Get Certified
              </a>
            </div>
          </div>
        )}

        {/* <!-- Notifications Section --> */}
        {/* <PhNotifications /> */}
        {/* <!-- Certification Status --> */}
        {/* <PhCertification /> */}

        {isCertified() && photoshoots.length === 0 && (
          <div className="mt-2 text-sm text-gray-600 font-bold  w-full">
            <div className="bg-yellow-100 text-yellow-800 w-full mb-4 p-2 rounded flex items-center">
              <i className="fas fa-exclamation-triangle mr-2"></i>
              No active photoshoots at the moment. Please check back later.
            </div>
          </div>
        )}

        {/* If photoshoots have data */}
        {isCertified() && photoshoots.length > 0 && (
          <>
            <div className="dashboard-section">
              <h2 className="text-xl font-semibold text-gray-800 mb-4">
                Photoshoots
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
                {photoshoots.map((record) => (
                  <article className="project-tile bg-white">
                    <div className="p-4 bg-white">
                      <div className="flex items-start justify-between">
                        <div>
                          <h2 className="text-lg font-semibold text-gray-800">{`${getAttrArr(record.hotel_attrs)[0]} - ${getAttrArr(record.hotel_attrs)[1]}`}</h2>
                          <p className="text-sm text-gray-500 mt-1">
                            Type:{" "}
                            <span className="font-medium text-gray-700">
                              {hotel_types[record.hotel_type]}
                            </span>
                          </p>
                          <p className="text-sm text-gray-500">
                            Shoot Date:{" "}
                            <span className="font-medium text-gray-700">
                              {formatDate(record.date_from)} -{" "}
                              {formatDate(record.date_to)}
                            </span>
                          </p>
                          <p className="text-sm text-gray-500">
                            Photographer:{" "}
                            <span className="font-medium text-gray-700">
                              {record.photographer_name}
                            </span>
                          </p>
                          <p className="text-sm text-gray-500">
                            Status:{" "}
                            <span className="font-medium text-gray-700">
                              {status[record.status]}
                            </span>
                            {renderBell(record.status)}
                          </p>
                        </div>
                        {/*<div className="ml-3 text-right">
                          <div className={statusClasses[getStatusLabel(record.status)]}>
                            <i className="fa-solid fa-circle"></i>
                          </div>
                        </div>*/}
                      </div>

                      <div className="mt-4 flex space-x-3 text-xs">
                        {record.status === 0 && (
                          <a
                            href={`photographer-photoshoot-request/${record.id}`}
                            className="btn px-4 py-2 rounded text-white font-semibold text-sm flex items-center space-x-2 hover:opacity-90"
                          >
                            <i className="fa-regular fa-camera"></i>
                            <span>Verify Request</span>
                          </a>
                        )}

                        {record.status > 0 && (
                          <a
                            href={`photographer-photoshoot-details/${record.id}`}
                            className="btn inline-flex items-center justify-center px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700"
                          >
                            <i className="fas fa-eye mr-2"></i> View Details
                          </a>
                        )}

                        {false && (
                          <a
                            href="#"
                            className="cta-btn inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-gray-800 rounded hover:bg-gray-100 ctaBrandTeam"
                          >
                            <i className="fas fa-comments mr-2"></i> Contact
                            Brand Team
                          </a>
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PhDashboard;
